
jQuery( ( $ ) => {
	$( '.ticket-insurance-message a' ).addClass( 'primary-color' );

	$( 'input[name="ticket-insurance"]' ).each( function ( _, el ) {
		if ( $( el ).is( ':checked' ) ) {
			console.log( el );
			$( el ).closest( '.card' ).addClass( 'border-primary' );
		}
	} );

	$( 'input[name="ticket-insurance"]' ).change( function() {
		$( '.card' ).removeClass( 'border-primary' );

		if ( $( this ).is( ':checked' ) ) {
			$( this ).closest( '.card' ).addClass( 'border-primary' );
		}
	} );

	$( '#delivery-options-form' ).ready( function() {
		checkToSeeIfItemAlreadyChecked( 'ticket' );
		checkToSeeIfItemAlreadyChecked( 'merch' );
		autoSelectDeliveryOptionsTsAndCsCheck();
	} );

	$( '#auto-select-delivery-option-form' ).ready( function() {
		// As there are no delivery options this just checks to see if Ts & Cs are clicked.  No need to also assess if delivery options have been selected.
		autoSelectDeliveryOptionsTsAndCsCheck();
	} );

	function autoSelectDeliveryOptionsTsAndCsCheck() {
		if( $( '#termsCheckbox' ).is( ':checked' ) ) {
			$( '#continue-to-payment-btn' ).removeAttr( 'disabled' );
		} else {
			$( '#continue-to-payment-btn' ).prop( 'disabled', true );
		}
	}

	function checkToSeeIfItemAlreadyChecked( item ) {
		$( `.delivery-option-${item}` ).each( function() {
			if( $( this ).is( ':checked' ) && 'ticket' === item ) {
				addTicketPostageFees( this );
			} else if ( $( this ).is( ':checked' ) && 'merch' === item ){
				addMerchPostageFees( this );

			}
		} );
	}

	$( '.delivery-option-ticket' ).change( function() {
		addTicketPostageFees( this );
		lastSelectedDeliveryOption( this );
		$( '#delivery-options-form' ).submit();
	} );

	$( '.delivery-option-merch' ).change( function() {
		addMerchPostageFees( this );
		lastSelectedDeliveryOption( this );
		$( '#delivery-options-form' ).submit();
	} );

	$( '.delivery-option-other' ).click( function( ) {
		lastSelectedDeliveryOption( this );
		$( '#delivery-options-form' ).submit();
	} );

	function lastSelectedDeliveryOption( HTMLElement ) {
		$( '#lastSelectedDeliveryOption' ).remove();
		const deliveryOption = $( HTMLElement ).attr( 'value' );
		const name = 'lastSelectedDeliveryOption';
		const value = deliveryOption;
		const id = 'lastSelectedDeliveryOption';
		const input = $( '<input>', {
			type: 'hidden',
			name: name,
			value: value,
			id: id
		} );
		$( '.your-details-form' ).append(
			input
		);
	}


	function addMerchPostageFees( HTMLElement ) {
		$( '#itemFeesMerch' ).remove();
		if( $( HTMLElement ).data( 'fee-id' ) ) {
			const name = 'itemFeesMerch';
			const value = $( HTMLElement ).data( 'fee-id' );
			const id = 'itemFeesMerch';
			const input = $( '<input>', {
				type: 'hidden',
				name: name,
				value: value,
				id: id
			} );
			$( '.your-details-form' ).append(
				input
			);
		}
	}


	function addTicketPostageFees( HTMLElement ) {
		$( '#itemFeesTickets' ).remove();
		if( $( HTMLElement ).data( 'fee-id-postage' ) ) {
			const name = 'itemFeesTickets';
			const value = $( HTMLElement ).data( 'fee-id-postage' );
			const id = 'itemFeesTickets';
			const input = $( '<input>', {
				type: 'hidden',
				name: name,
				value: value,
				id: id
			} );
			$( '.your-details-form' ).append(
				input
			);
		}
	}

	// Your Details page

	$( '#termsCheckbox' ).click( function() {
		checkToEnableContinueToPaymentBtn();
		autoSelectDeliveryOptionsTsAndCsCheck();
	} );

	//added by me
	$( '.ticket-insurance-radio' ).change( function() {
		checkToEnableContinueToPaymentBtn();
		autoSelectDeliveryOptionsTsAndCsCheck();
		$( '#submit-ticket-insurance-form' ).submit();
	} );


	function checkIfDeliveryOptionSelected( item ) {
		let checkFound = false;
		$( `.delivery-option-${item}` ).each( function() {
			if( $( '#termsCheckbox' ).is( ':checked' ) && $( this ).is( ':checked' ) ) {
				$( '#continue-to-payment-btn' ).removeAttr( 'disabled' );
				checkFound = true;
				return false;
			} else {
				$( '#continue-to-payment-btn' ).prop( 'disabled', true );
			}
		} );
		if( 'other' === item && false === checkFound ){
			checkTicketAndMerchRadioButtons();
		}
	}

	function checkIfMultipleDeliveryOptionSelected( item1, item2 ) {
		let item1Result = false;
		$( `.delivery-option-${item1}` ).each( function() {
			if( $( '#termsCheckbox' ).is( ':checked' ) && $( this ).is( ':checked' ) ) {
				item1Result = true;
			} else {
				$( '#continue-to-payment-btn' ).prop( 'disabled', true );
			}
		} );
		if( item1Result ) {
			$( `.delivery-option-${item2}` ).each( function() {
				if( $( '#termsCheckbox' ).is( ':checked' ) && $( this ).is( ':checked' ) ) {
					$( '#continue-to-payment-btn' ).removeAttr( 'disabled' );
					return false;
				} else {
					$( '#continue-to-payment-btn' ).prop( 'disabled', true );
				}
			} );
		}
	}

	function checkToEnableContinueToPaymentBtn(){
		if( $( '#radio-0' ).length ) {
			checkIfDeliveryOptionSelected( 'other' );
		} else if( $( '#radio-1' ).length ) {
			checkIfDeliveryOptionSelected( 'other' );
		} else if( $( '#radio-4' ).length ) {
			checkIfDeliveryOptionSelected( 'other' );
		}

		else {
			checkTicketAndMerchRadioButtons();
		}
	}


	$( '#delivery-options-form' ).ready( function() {
		checkToEnableContinueToPaymentBtn();
	} );

	function checkTicketAndMerchRadioButtons(){
		if( $( '.delivery-option-merch' ).length &&  $( '.delivery-option-ticket' ).length ) {
			checkIfMultipleDeliveryOptionSelected( 'merch', 'ticket' );
		} else if ( $( '.delivery-option-merch' ).length ) {
			checkIfDeliveryOptionSelected( 'merch' );
		} else if( $( '.delivery-option-ticket' ).length ) {
			checkIfDeliveryOptionSelected( 'ticket' );
		}
	}

} );
